import { gql } from '@/__generated__';

const DEVICES_ANALYSIS_GET_DEVICES_AVAILABLE_FIELDS = gql(`#graphql
  query DevicesAnalysis_GetDevicesAvailableFields($input: DevicesInput, $timeseriesInput: MetricTimeseriesInput) {
    devices(input: $input) {
      id
      metrics {
        id
        availableFields
        flow {
          unit
        }
        level {
          unit
        }
        timeseries(input: $timeseriesInput) {
          metricField
          unit
        }
      }
    }
  }
`);

export default DEVICES_ANALYSIS_GET_DEVICES_AVAILABLE_FIELDS;
